"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AssetNameCell = function AssetNameCell(_ref) {
  var assetName = _ref.cellData;

  if (assetName) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "asset-name"
    }, assetName);
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "no-asset-found"
  });
};

AssetNameCell.propTypes = {
  cellData: _propTypes["default"].string
};
AssetNameCell.defaultProps = {
  cellData: ''
};
var _default = AssetNameCell;
exports["default"] = _default;